import { PrimarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import Box from '../Box'
import { canSeeGetLastOtpButton, getLastPmsOtpDisplay } from './lastPmsOtpDisplay'
import styles from './LastPmsOtp.module.scss'

const LastPmsOtp = ({ isCsmUser, isInternalAdmin }) => {
  const { addToast } = useToasts()
  const [isLoading, setIsLoading] = useState(false)
  const [lastOtp, setLastOtp] = useState(null)

  if (!canSeeGetLastOtpButton({ isCsmUser, isInternalAdmin })) {
    return null
  }

  const display = lastOtp ? getLastPmsOtpDisplay(lastOtp) : null

  async function handleGetLastOtp() {
    setIsLoading(true)
    try {
      const result = await pmsApi.getLastPmsAuthOtp()
      setLastOtp(result)
    } catch (error) {
      addToast(`Failed to get last OTP: ${error.toString()}`, {
        appearance: 'error',
        autoDismiss: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Box title="PMS auth OTP">
      <PrimarySmallButton type="button" disabled={isLoading} onClick={handleGetLastOtp}>
        {isLoading ? 'Loading...' : 'Get Last OTP'}
      </PrimarySmallButton>
      {display && (
        <div className={styles.result}>
          {display.isEmpty ? (
            <p className={styles.emptyState}>{display.otpLabel}</p>
          ) : (
            <>
              <div className={styles.row}>
                <span className={styles.label}>OTP</span>
                <span
                  className={
                    display.hasExtractedOtpCode ? styles.otpValue : styles.emptyCode
                  }
                >
                  {display.otpLabel}
                </span>
              </div>
              <div className={styles.row}>
                <span className={styles.label}>Received on</span>
                <span className={styles.value}>{display.receivedOnLabel}</span>
              </div>
            </>
          )}
        </div>
      )}
    </Box>
  )
}

export default LastPmsOtp
